export default "__VITE_ASSET__lUd7xXEh__"